module.exports = __webpack_public_path__ + "static/media/logo-avatar.0e15652a.png";